import { combineReducers } from 'redux';

import application from './application';

const rootReducer = combineReducers({
    application
});

export default rootReducer;
